import Dialog from "../../General/ConfirmableDialog";
import {
  useState } from "react";
import useAuth from "../../../hooks/useAuth";
import { apiVariable } from "../../../api/apiVariable";
import axios from "axios";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
  CircularProgress,
} from "@mui/material";
import StatusSnackbar from "../../General/StatusSnackbar/StatusSnackbar";

interface ExcelUploadPopupProps {
  open: boolean;
  onClose: () => void;
  fileType: string;
}

const ExcelUploadPopup: React.FC<ExcelUploadPopupProps> = ({
  open,
  onClose,
  fileType,
}) => {
  const [file, setFile] = useState<File | null>(null);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const { token } = useAuth();

  const handleSnackbarClose = () => setStatus("idle");

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setFile(event.target.files[0]);
    }
  };

  const handleFileUpload = async () => {
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      setLoading(true);
      try {
        await axios.post(`${apiVariable}/uploadExcel`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          params: {
            fileType,
          },
        });
        setStatus("success");
        onClose();
      } catch (error: any) {
        setStatus("error");
        setErrorMessage(error.response.data || "Failed to upload file");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Upload Excel</DialogTitle>
        <DialogContent>
          <Box sx={{ marginBottom: 2 }}>
            <FormControl fullWidth>
              <TextField
                type="file"
                onChange={handleFileChange}
                variant="outlined"
                inputProps={{ accept: "" }}
              />
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => onClose()}
            color="secondary"
            variant="outlined"
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleFileUpload}
            color="primary"
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Upload"}
          </Button>
        </DialogActions>
      </Dialog>
      <StatusSnackbar
        status={status}
        successMessage={`File uploaded successfully`}
        errorMessage={errorMessage}
        handleClose={handleSnackbarClose}
      />
    </>
  );
};

export default ExcelUploadPopup;
